<template>
  <div class="class_list">
    <div class="mask" v-if="guideShow">
      <div class="swiper-container swiper-no-swiping" :class="{'opacityClass':opacityClass}">
      <div class="swiper-wrapper">
        <div
          v-for="(item,index) in classList"
          class="swiper-slide"
          :key="index"
          :class="{'opacityClass':item.experienceSubType!=26}"
        >
          <div class="sub_slide novice_class" v-if="index<10">
            <h2 class="title">{{item.subjectName}}</h2>
            <div class="grade"></div>
            <div class="content">
              <img :src="item.newBgImg" alt="">
              <div :class="{'test_student':item.subName}">
                <h2>{{item.newName}}</h2>
              </div>
            </div>
          </div>
          <div class="guide" :class="{'guide-top':classList.length===1}">
            <p>点击卡片 <br /> 学习“新手课”，开启学习之旅</p>
            <button @click="hideGuide">我知道了</button>
          </div>
        </div>
      </div>
      </div>
    </div>
    <loadError textColor="#fff" @loadAgain="getListAgain" v-if="loadErrorShow" />
    <div class="swiper-container swiper-box" :class="{'opacityClass':opacityClass}">
      <div class="swiper-wrapper">
        <div
          v-for="(item,index) in classList"
          :class="[(disPlayInside(item.classStatus,'lessonIndex') && disPlay(item.grade,'gradeIndex') && disPlay(item.subject,'subjectIndex') && disPlay(item.classYear,'classYear') && disPlay(item.classSeasonId,'semesterIndex')) || item.experienceSubType==26?'show':'hide','swiper-slide','cursor']"
          @click="go_course(item)"
          :key="index"
        >
          <div :class="[classNameConfig[item.subject],'sub_slide',item.experienceSubType==26?'novice_class':'']">
            <h2 class="title">{{item.subjectName}}</h2>
            <div class="grade" v-if="item.experienceSubType==26"></div>
            <div class="grade" v-else>
              <span>{{item.grade == 31 ? '幼' : item.grade == 32 ? '全' : item.grade}}</span>
              <br />{{item.grade == 31 ? '儿园' : '年级'}}
            </div>
            <div class="in_class" v-if="item.classStatus==2"></div>
            <div class="content">
              <img :src="item.newBgImg" alt="">
              <div :class="{'test_student':item.subName}">
                <h2 :class="item.expireTime && 'whl-h2-padding'">{{item.newName}}</h2>
                <h2 v-if="item.subName">{{item.subName}}</h2>
                <p class="whl-textbook-type">{{item.bookVersionName}}</p>
                <p v-if="item.expireTime">有效期：{{item.expireTime}}</p>
<!--                <p>{{item.showTime.split(' ')[1]}}</p>-->
<!--                <span v-if="item.classYear && item.experienceSubType!=26">{{item.classYear}}年</span>-->
              </div>
            </div>
            <img src="../../../assets/img/class/end.png" v-if="item.classStatus==3" alt class="end" />
          </div>
          <p class="whl-expire-tag" v-if="item.expireTime">{{item.experienceTitle}}</p>
        </div>

      </div>
    </div>
    <div class="hint" v-if="!hintShow && !loadErrorShow && !isRequest">
      <span class="filter_hint" v-if='gradeIndex || lessonIndex || subjectIndex || classYear == "全部年份" || semesterIndex'>未找到满足条件的课程</span>
      <div v-else>
        <span>暂无课程</span>
<!--        <p>关注狸米网校微信服务号了解更多课程信息</p>-->
      </div>
    </div>
  </div>
</template>

<script>
import loadError from "../../basic/loadError";
import { mapState, mapMutations, mapActions } from "vuex";
import common from "common";
export default {
  name: "class_list",
  data() {
    return {
      classList: [],
      opacityClass: true,
      hintShow: true,
      swiper: null,
      loadErrorShow: false,
      isRequest: false,
      interval:null,
      dataState:[],
      classNameConfig: {
        '1': "subject_1",
        '2': "subject_2",
        '3': "subject_3"
      },
      // 所有学科的课程列表
      classInfoArr: []
    };
  },
  props:["guideShow"],
   computed: {
    ...mapState(["round_robin_interval","firstLogin",'gradeIndex', 'lessonIndex', 'subjectIndex', 'semesterIndex', 'classYear', 'bookVersion','memberStatus','oldUser','subjectInTab'])
  },
  watch:{
    guideShow(val){
      if(val){
        this.$nextTick(()=>{
          new Swiper(".swiper-no-swiping", {
            slidesPerView: "auto",
            centerInsufficientSlides: true,
            spaceBetween: 65
          });
        });
      }
    }
  },
  components: {
    loadError
  },
  created() {
    this.getList();
  },
  mounted() {
    this.eventHub();
  },
  updated() {
    this.swiperupdateSize();
  },
  methods: {
    ...mapActions(["getClassList","getLessonsState"]),
    ...mapMutations(["saveClassInfo","refreshNet","saveSubjectInTab"]),
    eventHub() {
      this.$root.eventHub.$on('changeClassList', (subject)=> {
        const findObj = this.classInfoArr.find(v => v.subject === subject);
        this.classList = findObj.classList;
      })
    },
    hideGuide(){
      this.$root.eventHub.$emit("showPopup", "guideShow");
    },
    getListAgain() {
      // this.$root.eventHub.$emit("createLog", {
      //   id: "LMTrackEventFailureButton"
      // });
      this.getList();
    },
    getState() {
      this.getLessonsState({
        classIds: this.dataState,
        roundRobinInterval: this.round_robin_interval,
      }).then(({ res, ok }) => {
        if (!ok || !res || !res.length) return;
        this.getList(false);
      });
    },
    getList(needLoading=true) {
      this.loadErrorShow = false;
      this.isRequest = true;
      this.dataState = [];
      this.getClassList({data:{
        client: common.client,
        version:common.version,
        firstLoginCheck:(this.firstLogin),
        bookVersion: this.bookVersion,
        memberStatus: this.memberStatus,
        oldUser: this.oldUser
      },config:{
         needLoading: needLoading,
      }}).then(({ res, ok }) => {
        this.isRequest = false;
        if (!ok) {
          this.classList = [];
          this.loadErrorShow = true;
          return;
        }
        const classInfoArr = res.classInfo || [];
        this.classInfoArr = classInfoArr;
        const subjectArr = [];
        if(classInfoArr.length > 0) {
          if( this.subjectInTab ) {
            const index = classInfoArr.findIndex(v=>v.subject == this.subjectInTab);
            if(index != -1) {
              this.classList = classInfoArr[index].classList;
            }else {
              this.saveSubjectInTab(classInfoArr[0].subject);
              this.classList = classInfoArr[0].classList;
            }
          } else {
            this.saveSubjectInTab(classInfoArr[0].subject);
            this.classList = classInfoArr[0].classList;
          }

          for(let v of classInfoArr) {
            subjectArr.push({subject: v.subject, subjectName: v.subjectName, expireTime: v.expireTime, expireTitle: v.expireTitle})
          }
        }
        this.$parent.getClassList(this.classList, subjectArr);
        setTimeout(() => {
          this.opacityClass = false;
          this.createSwiper();
          //显示公告
          this.$root.eventHub.$emit("updateClassListState", false);
        }, 0);
        this.dataState = this.classList.map((v)=>v.classId);
        // experienceSubType:26体验课
        if( this.firstLogin==1 && this.classList.some((v)=>v.experienceSubType==26)){
          this.$emit('getListSuccess')
        }
        // coach delete
        // if(!this.interval && this.dataState.length){
        //   this.interval = setInterval(this.getState,this.round_robin_interval * 1000);
        // }
      }, err => {
        this.isRequest = false;
        this.loadErrorShow = true;
        this.classList = [];
      }).catch(err => {
        this.isRequest = false;
        this.loadErrorShow = true;
        this.classList = [];
      });
    },
    createSwiper() {
      //创建swiper
      this.swiper = new Swiper(".swiper-box", {
        slidesPerView: "auto",
        //centeredSlides: true,
        paginationClickable: true,
        centerInsufficientSlides: true, //当slides的总数小于slidesPerView时，slides居中。
        spaceBetween: 65, //slide之间的距离
        observer: true,
        observeParents: true,
        mousewheel: true,
        on: {
          slideChangeTransitionEnd: function(){
            common.setSession('classListActiveIndex',this.activeIndex);
          },
        },
      });
    },
    swiperupdateSize() {
      //更新swiper
      if(this.swiper && this.swiper.update){
        let index = common.getSession('classListActiveIndex') || 0;
        this.swiper.update(true)
        this.swiper.slideTo(index,0,false);
      }
      this.hintShow = document.getElementsByClassName("show").length;
    },
     disPlayInside(index,type) {
       if (!this[type]) return true
       if (this[type] == 1) {
         return index == 1 || index == 2
       } else {
         return index == 3
       }
     },
     disPlay(index,type) {
      //筛选班级
      // console.log(index,type, !this[type] || this[type]==index)
      return !this[type] || this[type] == '全部年份' || this[type]==index || (type == 'gradeIndex' && this[type] == 31 && index == 32);
      // return (
      //   (this.gradeIndex == 0 && this.lessonIndex == 0) ||
      //   (this.gradeIndex == 0 && this.lessonIndex == index1) ||
      //   (this.lessonIndex == 0 && this.gradeIndex == index2) ||
      //   (this.gradeIndex == index2 && this.lessonIndex == index1)
      // );
    },
    go_course(item) {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      let index = this.classList.findIndex(v => {
        return v.classId == item.classId;
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventClassCardClicked",
        data: {
          class_Id: item.classId,
          index: 1 + index,
          count: this.classList.length
        }
      });
      this.saveClassInfo(item);
      //进入课时列表页
      this.$router.push({ name: "course", params: { from: "class" } });
    }
  },
  beforeDestroy(){
    clearInterval(this.interval);
    this.$root.eventHub.$off('changeClassList');
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.class_list {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  /*margin-top: -114px;*/
}

.swiper-container {
  width: 100%;
  padding: 20px 125px 0 125px;
  box-sizing: border-box;
}

.swiper-wrapper {
  text-align: center;
  margin: 0 auto;
  padding-top: 10px;
}

.swiper-slide {
  width: 310px;
  height: 375px;
  border-radius: 48px 48px 195px 195px;
  background: rgba(255, 255, 255, 0.7);
  text-align: left;
}
.whl-expire-tag {
  width: 115px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e13131;
  color: #fff;
  position: absolute;
  right: -40px;
  top: -25px;
  font-size: 24px;
  border-radius: 13px 20px 20px 0px;
}
.sub_slide {
  width: 310px;
  height: 370px;
  border-radius: 48px 48px 195px 195px;
  background: #ffffff;
  font-family: HYZhengYuan;
  .title {
    padding-top: 3px;
    letter-spacing: 4px;
    height: 68px;
    font-size: 45px;
    font-weight: 800;
    line-height: 68px;
    padding-left: 32px;
    color: #3476DD;
  }
  .grade {
    position: absolute;
    right: 35px;
    top: 0px;
    width: 53px;
    height: 87px;
    background: url(../../../assets/img/class/grade_bg_default.png) no-repeat;
    background-size: 100%;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    line-height: 24px;
    padding-top: 17px;
    span {
      font-size: 25px;
    }
  }
  .in_class {
    width: 98px;
    height: 67px;
    position: absolute;
    left: -17px;
    top: 78px;
    background: url(../../../assets/img/class/in_class_default.png) no-repeat;
    background-size: 100%;
    animation: rotateImg 1.2s  infinite ease;

  }
  .content {
    width: 300px;
    height: 295px;
    background: #FF8066;
    border-radius: 8px 8px 190px 190px;
    margin: 0 auto;
    overflow: hidden;
    text-align: center;
    color: #ffffff;
    img{
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 188px;
    }
    h2{
      padding-top:10px;
      white-space: nowrap;
      font-size: 26px;
      width: 75%;
      margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h2.whl-h2-padding {
      padding-top: 5px;
    }
    p{
      font-size: 16px;
      padding:0 0 0 0;
      opacity: .8;
    }
    span{
      opacity: .8;
      font-size: 14px;
    }
    .test_student{
      h2{
        padding: 0;
        font-size: 20px;
      }
      p{
        padding: 0;
      }
    }
  }
  .end {
    width: 210px;
    height: 132px;
    position: absolute;
    right: -20px;
    bottom: 30px;
  }
}
.subject_1 {
  .title {
    color: #0086df;
  }
  .grade {
    background: url(../../../assets/img/class/grade_bg_1.png) no-repeat;
    background-size: 100%;
  }
  .in_class {
    background: url(../../../assets/img/class/in_class_1.png) no-repeat;
    background-size: 100%;
  }
  .content {
    background: #49A4FF;
  }
}
.subject_2 {
  .title {
    color: #eb8509;
  }
  .grade {
    background: url(../../../assets/img/class/grade_bg_2.png) no-repeat;
    background-size: 100%;
  }
  .in_class {
    background: url(../../../assets/img/class/in_class_2.png) no-repeat;
    background-size: 100%;
  }
  .content {
    background: #FFB254;
  }
}
.subject_3 {
  .title {
    color: #8750c6;
  }
  .grade {
    background: url(../../../assets/img/class/grade_bg_3.png) no-repeat;
    background-size: 100%;
  }
  .in_class {
    background: url(../../../assets/img/class/in_class_3.png) no-repeat;
    background-size: 100%;
  }
  .content {
    background: #9D7BF1;
  }
}
.novice_class{
  .title {
    color:#009C75;
  }
  .grade {
    background: url(../../../assets/img/class/grade_bg_novice.png) no-repeat;
    background-size: 100%;
  }
  .in_class {
    background: url(../../../assets/img/class/in_class_novice.png) no-repeat;
    background-size: 100%;
  }
  .content {
    background: #14CC9E;
  }
  .content .test_student h2{
    font-size:26px;
    margin-top: 10px;
  }
}
.hint {
  position: absolute;
  margin-top: -150px;
  width: 100%;
  opacity: 0.75;
  color: #ffffff;
  .filter_hint{
    display:block;
    font-size:24px;
    margin-top:150px;
  }
  span {
    font-size: 32px;
    font-weight: normal;
    opacity: .75;
  }
  p {
    font-family: PingFang_Medium;
    font-size: 18px;
    margin-top: 20px;
  }
}
.opacityClass {
  opacity: 0;
  visibility: hidden;
}
.hide {
  display: none !important;
}
.mask{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
  display: flex;
  align-items: center;
  padding-top: 133px;
  .swiper-container{
    pointer-events: none;
    overflow:inherit;
  }
  .guide{
    color: #ffffff;
    position: absolute;
    width: 410px;
    left: 335px;
    top: 100px;
    background: url(../../../assets/img/class/guide.png) no-repeat left 18px;
    padding-left: 90px;
    background-size:70px 33px;
    p{
      font-size: 24px;
      line-height: 40px;
    }
    button{
      color: #E8E9E9;
      font-size: 22px;
      border: 1px solid #E8E9E9;
      width: 127px;
      height: 60px;
      border-radius:30px;
      margin-top: 30px;
      cursor: pointer;
      pointer-events: auto;
    }
  }
  .guide-top{
    top: -95px;
    left:155px;
    background-position: left 35px;
    button{
      float: right;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class_list.vue